// Toast interface (for widget, we'll use simple console/alerts)
export interface ToastProps {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
}

// Simple toast function for widget with visual feedback
export function toast({ title, description, variant }: ToastProps) {
  const message = `${title || ''}${description ? `: ${description}` : ''}`;
  
  // Log to console for debugging
  if (variant === "destructive") {
    console.error('🚨 MockDetector:', message);
  } else {
    console.log('✅ MockDetector:', message);
  }
  
  // Create visual toast notification
  if (typeof document !== 'undefined') {
    const toastEl = document.createElement('div');
    toastEl.className = `mockdetector-toast ${variant === 'destructive' ? 'error' : 'success'}`;
    toastEl.textContent = message;
    toastEl.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: ${variant === 'destructive' ? '#dc2626' : '#16a34a'};
      color: white;
      padding: 12px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 999999;
      font-family: system-ui, -apple-system, sans-serif;
      font-size: 14px;
      animation: slideIn 0.3s ease-out;
      max-width: 400px;
    `;
    
    // Add animation styles if not present
    if (!document.getElementById('mockdetector-toast-styles')) {
      const style = document.createElement('style');
      style.id = 'mockdetector-toast-styles';
      style.textContent = `
        @keyframes slideIn {
          from { transform: translateX(400px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOut {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(400px); opacity: 0; }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(toastEl);
    
    // Auto-remove after 3 seconds
    setTimeout(() => {
      toastEl.style.animation = 'slideOut 0.3s ease-in';
      setTimeout(() => toastEl.remove(), 300);
    }, 3000);
  }
}

// Hook (for compatibility with component code)
export function useToast() {
  return {
    toast,
    dismiss: () => {},
    toasts: []
  };
}
